export interface PublicProduct {
  id: string;
  name: string;
  slug: string;
  description: string;
  product_type: 'scheduled_seats' | 'flat_fee';
  currency: string;
  price?: number;
  total_amount?: number;
  image_url?: string;
  tags?: string[];
  offerings?: {
    available_seats: number;
    is_full?: boolean;
    price?: number;
    total_amount?: number;
  }[];
}

export interface ProductOffering {
  id: string;
  session_date: string;
  label?: string;
  location?: string;
  available_seats: number;
  is_full: boolean;
  price: number;
  tax_amount: number;
  total_amount: number;
  currency: string;
}

export interface ProductDetail {
  id: string;
  name: string;
  slug: string;
  description: string;
  product_type: 'scheduled_seats' | 'flat_fee';
  currency: string;
  price?: number;
  tax_amount?: number;
  total_amount?: number;
  tax_rate?: number;
  offerings?: ProductOffering[];
}

export interface AppointmentTaker {
  email: string;
  userId: string;
  displayName: string;
  slug: string | null;
  allowSaturday: boolean;
  allowSunday: boolean;
  businessHours: {
    start: number;
    startMinute: number;
    end: number;
    endMinute: number;
  } | null;
  timeZone: string;
  fee: number;
  currency: string;
  allowWalkIn: boolean;
  allowCall: boolean;
  officeAddress: {
    name: string;
    fullAddress: string;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    province?: string;
    postalCode?: string;
  } | null;
}

export const formatProductPrice = (product: PublicProduct | ProductDetail) => {
  let amount = product.total_amount ?? product.price ?? 0;
  
  if (product.product_type === 'scheduled_seats' && product.offerings && product.offerings.length > 0) {
    const offeringAmounts = product.offerings
      .map(o => ('total_amount' in o ? o.total_amount : undefined) ?? o.price ?? 0)
      .filter(a => a > 0);
    if (offeringAmounts.length > 0) {
      amount = Math.min(...offeringAmounts);
    }
  }

  return `${product.currency} $${amount.toFixed(2)}`;
};
